import request from "@/utils/request";
import Qs from "qs";

// 图片上传Oss（可多文件上传）
export function ossUpload(data) {
  return request({
    url: "/common/admin_oss_upload",
    method: "post",
    // ContentType:'multipart/form-data',
    data: Qs.stringify(data),
  });
}

// 车位费用配置列表
export function carportList(data) {
  return request({
    url: "/carport/type_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加车位费用配置
export function carportAdd(data) {
  return request({
    url: "/carport/add_type",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑车位费用配置
export function carportEdit(data) {
  return request({
    url: "/carport/edit_type",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除车位费用配置
export function carportDel(data) {
  return request({
    url: "/carport/del_type",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 车位费用配置详情
export function carportInfo(data) {
  return request({
    url: "/carport/type_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 包月车位申请列表
export function applyList(data) {
  return request({
    url: "/carport/apply_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看车牌申请
export function apply_info(data) {
  return request({
    url: "/carport/apply_info",
    method: "post",
    data: Qs.stringify(data),
  });
}



// 删除包月申请记录
export function applyDel(data) {
  return request({
    url: "/carport/del_apply",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 车位申请审核
export function examine(data) {
  return request({
    url: "/carport/examine",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 车辆缴费记录
export function orderList(data) {
  return request({
    url: "/carport/order_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 添加停车优惠券
export function couponsAdd(data) {
  return request({
    url: "/carport/add_coupons",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 停车优惠券列表
export function couponsList(data) {
  return request({
    url: "/carport/coupons_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 删除停车优惠券
export function couponsDel(data) {
  return request({
    url: "/carport/coupons_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 车辆缴费记录_退款（状态为已支付的可以进行退款）
export function order_refund(data) {
  return request({
    url: "/carport/order_refund",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 车辆出入记录
export function get_car_record(data) {
  return request({
    url: "/carport/get_car_record",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 僵尸车列表
export function zombieList(data) {
  return request({
    url: "/zombie_vehicle/get_zombie_vehicle_list",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 僵尸车详情
export function zombieInfo(data) {
  return request({
    url: "/zombie_vehicle/get_zombie_vehicle_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 僵尸车置为出场
export function zombieOut(data) {
  return request({
    url: "/zombie_vehicle/set_car_record_out",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 导出停车缴费记录
export function order_export(data) {
  return request({
    url: "/carport/order_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}


// 车牌申请列表
export function sub_apply_list(data) {
  return request({
    url: "/carport/sub_apply_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 编辑包月申请的时间
export function sub_edit(data) {
  return request({
    url: "/carport/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 车牌审核
export function sub_examine(data) {
  return request({
    url: "/carport/sub_examine",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 优惠券模板列表
export function tpl_lists(data) {
  return request({
    url: "/carport/tpl_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加优惠券模板
export function tpl_add(data) {
  return request({
    url: "/carport/tpl_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看优惠券模板
export function tpl_info(data) {
  return request({
    url: "/carport/tpl_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑优惠券模板
export function tpl_edit(data) {
  return request({
    url: "/carport/tpl_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除优惠券模板
export function tpl_del(data) {
  return request({
    url: "/carport/tpl_del",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 优惠券列表
export function coupons_list(data) {
  return request({
    url: "/carport/coupons_list",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加优惠券
export function add_coupons(data) {
  return request({
    url: "/carport/add_coupons",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看优惠券
export function coupons_info(data) {
  return request({
    url: "/carport/coupons_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 作废优惠券
export function coupons_invalid(data) {
  return request({
    url: "/carport/coupons_invalid",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取车场信息
export function get_car_site(data) {
  return request({
    url: "/carport/get_car_site",
    method: "post",
    data: Qs.stringify(data),
  });
}